const fiveKPdfStyles = {
    tableHeader: {
        fontSize: 10,
        bold: true,
        fillColor: "#f69c4c", // Background color
        color: "white", // Text color
        margin: [0, 1],
        alignment: "center",
        border: [true, true, true, true, '#b1b1b1']
    },
    dataRow: {
        fontSize: 10,
        margin: [0, 0],
        alignment: "left",
    },
    dataRowBold: {
        fontSize: 10,
        bold: true,
        margin: [0, 0],
        alignment: "left",
    },
    dataRowQue: {
        fontSize: 5,
        margin: [0, 0],
        alignment: "left",
    },
    dataRowAns: {
        fontSize: 5,
        margin: [0, 0],
        alignment: "center",
    },
    totalRowQue: {
        fontSize: 5,
        margin: [0, 0],
        bold: true,
        alignment: "left",
    },
    totalRow: {
        fontSize: 5,
        margin: [0, 0],
        bold: true,
        alignment: "center",
    },
    boldDataRow: {
        fontSize: 5,
        bold: true,
        margin: [0, 0],
        alignment: "center",
    },
    categoryStyle: {
        fontSize: 15,
        bold: true,
        color: "#d26300", // Text color
        alignment: "left",
        margin: [0, 25, 0, 10],
    },
    formTitleStyle: {
        fontSize: 13.5,
        bold: true,
        alignment: "left",
        margin: [40, 30, 0, 0],
    },
    pointsAchStyle: {
        fontSize: 9.5,
        bold: true,
        alignment: "left",
        margin: [0, 4, 0, 0],
    },
    queStyle: {
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [5, 5, 0, 5],
    },
    queContentStyle: {
        fontSize: 7,
        bold: false,
        alignment: "left",
        margin: [10, 5, 0, 0],
    },
    queContentStyleRed: {
        fontSize: 7,
        color: "red",
        bold: false,
        alignment: "left",
        margin: [10, 5, 0, 0],
    },
    queContentStyle1: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        margin: [10, 5, 0, 0],
    },
    headText1: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        color: "#1111",
        margin: [0, 5, 0, 0],
        transform: 'capitalize'
    },
    headText2: {
        fontSize: 7,
        bold: false,
        alignment: "left",
        margin: [0, 1, 0, 0],
        transform: 'capitalize'
    },
    headTexScore1: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        color: "#1111",
        color: "#d26300",
        margin: [0, 5, 0, 0],
        transform: 'capitalize'
    },
    headTexScore2: {
        fontSize: 7,
        bold: false,
        alignment: "left",
        color: "#d26300",
        margin: [0, 1, 0, 0],
        transform: 'capitalize'
    },
    headTexScore_fail: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        color: "red",
        margin: [0, 1, 0, 0],
        transform: 'capitalize'
    },
    headTexScore_other: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        color: "green",
        margin: [0, 1, 0, 0],
        transform: 'capitalize'
    },
    tableTitleStyle: {
        fontSize: 10,
        bold: true,
        color: "#d26300", // Text color
        alignment: "left",
        margin: [0, 15, 0, 0],
    },
    borderedText: {
        border: [true, false, false, false], // Only top border
        paddingTop: 5 // Adjust the padding top as needed
    },
    footerText: {
        fontSize: 12,
        bold: true,
        alignment: "center",
        margin: [10, 20, 10, 0],
    },
};

export {
    fiveKPdfStyles
}